let viewCartResolver = {

    viewCartModel: function (notificationService, cartService) {
        "ngInject";


            return cartService.retrieveViewCartModel().then(function (result) {

                return result;

            }).catch(function (errObject) {
                var msg = 'Failed to retrieve your cart. Please try again.';
                if (errObject.data != undefined && errObject.data.exception != undefined)
                    msg = errObject.data.exception;

                notificationService.notifyWithDefaults({
                    title: 'Error',
                    title_escape: false,
                    text: msg,
                    text_escape: false,
                    styling: "fontawesome",
                    type: "error",
                    icon: true,
                    buttons: {
                        sticker: false
                    },
                    delay: 3000
                }, 'custom_stack');

                errObject.error = true;
                errObject.errorText = msg;

                return errObject;
            });

    }
};

export default viewCartResolver;



// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-resolver.js